import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'timestamp'
})
export class TimestampPipe implements PipeTransform {
  transform(date: number): Date {
    return new Date(date*1000);
  }
}